// extracted by mini-css-extract-plugin
export var subtitle = "_da-2";
export var title = "_da-0";
export var titleNoWrap = "_da-1";